export default __webpack_public_path__ + "static/media/bookmark.305096c7.svg";